// Module
var code = `<tour-step-body><span translate="lti-refresh-tour-breadcrumbs-message"></span></tour-step-body><tour-step-footer><button type="button" class="tertiary-btn" ng-click="\$ctrl.tour.end()" translate="common_skip"></button> <button type="button" class="primary-btn" ng-click="\$ctrl.tour.next()" translate="common_next"></button></tour-step-footer>`;
// Exports
export default code;